import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Composant pour protéger les routes accessibles uniquement aux utilisateurs commerciaux
const CommercialRoute = () => {
  const { isAuthenticated, isCommercial, loading } = useAuth();
  
  // Afficher un indicateur de chargement pendant la vérification de l'authentification
  if (loading) {
    return <div>Chargement...</div>;
  }
  
  // Rediriger vers la page de connexion si l'utilisateur n'est pas authentifié
  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace />;
  }
  
  // Rediriger vers la page de connexion si l'utilisateur n'a pas le rôle commercial
  if (!isCommercial) {
    return <Navigate to="/sign-in" replace />;
  }
  
  // Rendre les routes enfants si l'utilisateur a le rôle commercial
  return <Outlet />;
};

export default CommercialRoute;
